export default "__VITE_ASSET__d3e83166__"